import * as CONST from '../../constants';

const INITIAL_STATE = { loading: true, status: null, error: null };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONST.STATUS_CREATE_REQUEST:
      return { ...INITIAL_STATE, loading: true, status: null, error: null };
    case CONST.STATUS_CREATE_SUCCESS:
      return { ...INITIAL_STATE, loading: false, status: action.status, error: null };
    case CONST.STATUS_CREATE_ERROR:
      return { ...INITIAL_STATE, loading: false, error: action.error, status: null };
    case CONST.CLOSE_MODAL:
      return { ...INITIAL_STATE, loading: false, error: null, status: null };
    default:
      return state;
  }
};
